<!-- Center Wrapper -->
<!-- <div class="flex justify-center items-center h-screen bg-gray-50">
  <div
    class="video-box relative rounded-lg overflow-hidden shadow-md border border-pink-500 mt-8"
    [style.maxWidth]="maxWidth"
    [style.width]="width"
  >
    <ng-container *ngIf="!playVideoFlag; else videoPlayer">
      <div class="relative w-full h-full cursor-pointer" (click)="playVideo()">
        <img
          [src]="thumbnailUrl"
          alt="Video Thumbnail"
          class="object-cover w-full h-full"
        />
        <div
          class="absolute inset-0 bg-black bg-opacity-60 flex flex-col justify-center items-center text-white"
        >
          <div class="absolute top-4 right-4 text-white text-xl">
            <i class="fas fa-info-circle"></i>
          </div>
          <div
            class="bg-[#ff0000] rounded-2xl w-10 h-10 flex justify-center items-center shadow-lg transform hover:scale-105 transition"
          >
            <svg class="w-40 h-40 text-white" fill="white" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #videoPlayer>
      <iframe
        [src]="embedUrl"
        frameborder="0"
        allow="autoplay; encrypted-media"
        [style.width]="width"
        [style.height]="height"
        allowfullscreen
      ></iframe>
    </ng-template>
  </div>
</div> -->

<div class="flex justify-center items-center">
  <img [src]="imagePath" [style.height]="height" />
</div>
<div class="mb-5 text-center w-700px" *ngIf="isVideo == 'Welcome Video Node'">
  <p class="text-xl font-semibold mt-4">
    {{
      fields?.displayName != "" ? fields?.displayName : "Let's Begin your task"
    }}
  </p>
  <p class="text-md font-medium text-gray-600 px-7 mt-2">
    {{
      fields?.helpText != ""
        ? fields?.helpText
        : "Over the next few minutes, we will gather essential information about your
    organization. Our AI engine will process this data in the background and
    generate a tailored security roadmap designed specifically for your needs"
    }}
  </p>
</div>
